package dev.danko.roblox_craft_ai.shared.model

import kotlinx.serialization.Serializable

@Serializable
enum class PresetCategory {
    ENVIRONMENT,
    NPC,
    INTERIOR,
    WEAPON,
    ITEM,
    ANIMATION,
    SCRIPT,
    PERSONAL
}

@Serializable
enum class PresetDifficulty {
    EASY,
    MEDIUM,
    HARD
}

@Serializable
data class PromptPresetDto(
    val id: String,
    val category: PresetCategory,
    val title: String,
    val prompt: String,
    val description: String,
    val tags: List<String> = emptyList(),
    val difficulty: PresetDifficulty = PresetDifficulty.MEDIUM,
    val author: String = "Curated",
    val isPublic: Boolean = true,
    val createdAtUtc: Long = 0L,
    val preferredAssetType: AssetType? = null,
    val titleI18n: Map<String, String> = emptyMap(),
    val descriptionI18n: Map<String, String> = emptyMap()
) {
    fun localizedTitle(locale: String): String = titleI18n[locale] ?: title

    fun localizedDescription(locale: String): String = descriptionI18n[locale] ?: description
}
